import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "result-container pb" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", { href: "/ibook/#/card-detail" }, "跳转卡牌详情测试actionbar隐藏", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "result-container pb" }, "1111", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createTextVNode(" 1111 "),
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.doJumpFn(1))),
        style: {"padding":"20px"}
      }, "跳转百度"),
      _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.doJumpFn(2))),
        style: {"padding":"20px"}
      }, "跳转分享落地页"),
      _createElementVNode("div", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.doJumpFn(3))),
        style: {"padding":"20px"}
      }, "跳转题目解析页"),
      _createElementVNode("div", {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.doJumpFn(4))),
        style: {"padding":"20px"}
      }, "跳转设置"),
      _hoisted_2
    ]),
    _hoisted_3,
    _createElementVNode("button", {
      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goback && _ctx.goback(...args)))
    }, "goback"),
    _createElementVNode("button", {
      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.getStatusBarInfoFn && _ctx.getStatusBarInfoFn(...args)))
    }, "获取状态栏高度"),
    _createElementVNode("button", {
      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.closeActionBar && _ctx.closeActionBar(...args)))
    }, "隐藏状态栏"),
    _createElementVNode("button", {
      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.openActionBar && _ctx.openActionBar(...args)))
    }, "显示状态栏")
  ], 64))
}